import { render } from "./ManuInfoM.vue?vue&type=template&id=45bc700b"
import script from "./ManuInfoM.vue?vue&type=script&lang=js"
export * from "./ManuInfoM.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__